module.exports = __webpack_public_path__ + "img/d51ad9ac836a9f515b0e5633e11e4e27.png";


//////////////////
// WEBPACK FOOTER
// ./classes/items/nori/assets/sprites/nori.png
// module id = 72
// module chunks = 0